export const loginAuthActionTypes = {
	AUTHTOKEN: 'AUTHTOKEN',
};
